interface ConfirmationLoadedMessageData {
  type: "CONFIRMATION_LOADED";
  order_name?: string;
  return_id: string;
  timestamp: string;
}

export function fireReturnConfirmationLoadedEvent(
  returnId: string,
  orderIdentifier?: string,
): void {
  try {
    const message: ConfirmationLoadedMessageData = {
      type: "CONFIRMATION_LOADED",
      return_id: returnId,
      timestamp: new Date().toISOString(),
    };

    if (orderIdentifier) {
      message.order_name = orderIdentifier;
    }

    window.parent?.postMessage(message, "*");

    console.log("Return confirmation loaded event fired:", message);
  } catch (error) {
    console.error("Error firing return confirmation loaded event:", error);
  }
}
